import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { typography } from 'src/common/styles/typography';
import { media } from 'src/common/styles/breakpoints';
import { ContactPageRoute } from 'src/routes';
import { buildPublicUrlLink } from 'src/utils/buildPublicUrlLink';
import { FormattedMessage } from 'react-intl';
import FooterAnnotations from './FooterAnnotations';
import FooterDataInfo from './FooterDataInfo';
import FooterContentWrapper from './FooterContentWrapper';
import { SimpleLink, StyledRouterLink } from 'src/common/components/SimpleLink';

const Links = styled.div`
  grid-area: links;
  display: flex;
  flex-direction: column;
  gap: 13px;
  font-weight: bold;
`;

const StyledSimpleLink = styled(SimpleLink)`
  color: ${({ theme }) => theme.text.primary};
  text-decoration: none;
`;

const ContactItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3125rem;

  p {
    color: ${({ theme }) => theme.text.primary};
    font-family: ${typography.fontFamilyDefault};
    font-size: 1rem;
    font-weight: bold;
  }

  span {
    color: ${({ theme }) => rgba(theme.text.primary, 0.7)};
    font-family: ${typography.fontFamilyDefault};
    font-size: 1rem;
    ${media.w.min.px576(css`
      white-space: nowrap;
    `)}
  }
`;

const Contact = styled.div`
  grid-area: contact;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  ${media.w.min.px576(css`
    gap: 4rem;
    flex-direction: row;
    justify-content: space-between;
  `)}
`;

const Wrapper = styled.footer`
  margin-top: 2.5rem;
  border-top: 1px solid ${rgba('#DCDFEB', 0.3)};
  padding: 2.0625rem 0 2.1875rem 0;
  overflow: hidden;
  width: 100%;

  ${media.w.min.px576(css`
    padding: 3.5625rem 0 2.1875rem 0;
    margin-top: 2rem;
  `)}
`;

const Footer = () => {
  return (
    <Wrapper>
      <FooterContentWrapper>
        <FooterDataInfo />
        <Links>
          <StyledSimpleLink
            target="_blank"
            href={buildPublicUrlLink('docs/AIS_Polityka_prywatności.pdf')}
          >
            <FormattedMessage id="footer.privacyPolicy" />
          </StyledSimpleLink>
          <StyledSimpleLink
            target="_blank"
            href={buildPublicUrlLink('docs/AISGateway_regulamin.pdf')}
          >
            <FormattedMessage id="footer.statute" />
          </StyledSimpleLink>
          <StyledRouterLink to={ContactPageRoute}>
            {' '}
            <FormattedMessage id="footer.contact" />
          </StyledRouterLink>
        </Links>
        <Contact>
          <ContactItem>
            <p>
              <FormattedMessage id="footer.companyName" />
            </p>
            <span>AIS Gateway sp. z o.o.</span>
            <span>Warsaw Unit</span>
            <span>Rondo Daszyńskiego 1</span>
            <span>00-843&nbsp;Warszawa</span>
            <span>NIP: 5272933642</span>
          </ContactItem>

          <ContactItem>
            <p>
              <FormattedMessage id="footer.customerService" />
            </p>
            <span>contact@aisgateway.tech</span>
          </ContactItem>
        </Contact>
        <FooterAnnotations />
      </FooterContentWrapper>
    </Wrapper>
  );
};

export default Footer;
